
export type GetProjectsStatus = typeof GetProjectsStatus[keyof typeof GetProjectsStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProjectsStatus = {
  ALL: 'ALL',
  PUBLISHED: 'PUBLISHED',
  DRAFT: 'DRAFT',
} as const;
